import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    boxList: {
      background: theme.palette.background.default,
      borderRadius: "8px",
      width: "100%",
      marginTop: "0.8rem",
      display: "flex",
      justifyContent: "flex-start",
      position: "relative",
      padding: "4rem 1.2rem 2rem"
    },
    info: {
      display: "flex"
    },
    headerTxt: {
      position: "absolute",
      top: 8,
      left: 16,
      color: theme.palette.info.dark
    },
    icon: {
      marginRight: "0.6rem",
      "& path": {
        stroke: theme.palette.info.dark
      }
    },
    caption: {
      color: theme.palette.grey[700]
    },
    chipBox: {
      minHeight: "138px",
      maxHeight: "200px",
      overflow: "auto",
      "&::-webkit-scrollbar": {
        height: "14px",
        background: "#FFFFFF"
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 10,
        border: "4px solid #FFFFFF",
        height: "6px"
      },
      background: theme.palette.background.default,
      borderRadius: "8px",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      padding: "0.8rem 1.6rem",
      paddingTop: 0, // sticky
      marginTop: "0.8rem",
      "& .MuiChip-root": {
        justifyContent: "space-between",
        borderRadius: "2px"
      }
    },
    chipPaper: {
      boxShadow: "none",
      background: theme.palette.background.default,
      width: "100%",
      padding: 0,
      margin: 0,
      gap: 5,
      display: "flex",
      flexWrap: "wrap",
      listStyle: "none"
    },
    chipLi: {
      maxWidth: "100%"
    },
    chipText: {
      color: theme.palette.info.dark,
      // sticky
      position: "sticky",
      top: 0,
      background: theme.palette.background.default,
      paddingTop: "0.8rem",
      paddingBottom: "0.8rem"
    },
    chip: {
      cursor: "pointer",
      maxWidth: "100%",
      "& .MuiChip-label": {
        color: theme.palette.grey[900],
        fontSize: "1.2rem",
        lineHeight: "12px"
      }
    },
    fullWidth: {
      width: "100%"
    },
    deleteIcon: {
      marginRight: "1.4rem",
      width: "1rem"
    }
  }),
  {
    name: "MultipleAutocompleteTextInput"
  }
);

export default useStyles;
